// src/services/api.js
import axios from 'axios';
import { requestActivityController } from './requestActivity';
import { autoDownloadFailedRows } from '@/utils/downloadFailedRows';

const baseURL = process.env.VUE_APP_API_URL;

// console.log('API Base URL:', baseURL); // For debugging

const apiClient = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 100000,
});


// For file uploads, we'll use a longer timeout
export const fileUploadClient = axios.create({
  baseURL,
  timeout: 300000, // 5 minutes for file uploads
});


function attachInterceptors(client) {
  client.interceptors.request.use((config) => {
    const token = localStorage.getItem('jwt');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (requestActivityController.isImportRequest(config)) {
      config.timeout = Math.max(config.timeout || 0, 600000);
      const existingUploadProgress = config.onUploadProgress;
      config.onUploadProgress = (event) => {
        requestActivityController.setProgress(event);
        if (typeof existingUploadProgress === 'function') {
          existingUploadProgress(event);
        }
      };
    }

    return requestActivityController.begin(config);
  });

  client.interceptors.response.use(
    response => {
      requestActivityController.finish(response.config);
      // If this was a bulk-import response and the server returned per-row
      // errors, auto-trigger a CSV download of just the failed rows so the
      // user can fix and re-upload. Fires off the response path; never
      // blocks or alters the response itself.
      if (requestActivityController.isImportRequest(response.config)) {
        autoDownloadFailedRows(response);
      }
      return response;
    },
    error => {
      requestActivityController.finish(error.config || {});
      if (error.response?.status === 401) {
        localStorage.removeItem('jwt');
        localStorage.removeItem('userdata');
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
  );
}

attachInterceptors(apiClient);
attachInterceptors(fileUploadClient);

export default apiClient;
